module.exports = __webpack_public_path__ + "img/Y2KCY1.105b23a5.jpg";